import { Link } from 'react-router-dom';
import { useSessionFacets } from '../hooks/use-session-actions.js';

// What the index already says a session is about (operator, 30/10/2026): the facets of its note and of the object it
// works on, a quiet line under its name; nothing when there are none. Each leads to the server's sessions of that facet.

/** The server's session list on a facet */
export const facetListPath = (serverId: string, f: { dimension: string; value: string }) =>
  `/servers/${encodeURIComponent(serverId)}?facet=${encodeURIComponent(`${f.dimension}:${f.value}`)}`;

export function SessionFacets({ serverId, sessionId }: { serverId: string; sessionId: string }) {
  const { data } = useSessionFacets(serverId, sessionId);
  const facets = data?.facets ?? [];
  if (!facets.length) return null;
  return (
    <ul aria-label="What this session is about, from the index" className="mt-1.5 flex flex-wrap gap-1.5">
      {facets.map((f) => (
        <li key={`${f.dimension}|${f.value}`}>
          <Link to={facetListPath(serverId, f)} title={`The sessions about ${f.dimension}: ${f.value}`}
            className="block rounded px-1.5 py-0.5 text-xs hover:underline focus-visible:outline focus-visible:outline-2"
            style={{ border: '1px solid var(--color-border-2)', color: 'var(--color-text-2)', textDecoration: 'none' }}>
            <span style={{ color: 'var(--color-text-3)' }}>{f.dimension} </span>{f.value}
          </Link>
        </li>
      ))}
    </ul>
  );
}
